<template>
  <div id="home">
    <div v-show="!loading">
      <header>
        <div class="content headerTop flex-between">
          <p>欢迎使用中资云企业综合服务平台</p>
          <div class="flex-between">
            <div class="rightItem">
              <span>您好，</span>
              <span class="user" @click="goHome">{{ userName }}</span>
            </div>
            <div class="rightItem" @click="loginOut">退出账号</div>
          </div>
        </div>
      </header>
      <nav>
        <div class="content flex-between">
          <div class="logo">
            <img @click="goHome" src="../assets/imgs/home/logo.png" alt />
          </div>
          <div class="flexr0c">
            <div class="infoBox" id="selectBox" ref="selectBox">
              <img v-on-clickaway="closeBell" @click="bell = !bell" src="../assets/imgs/home/info.png" alt />
              <span v-if="notReadCount != 0"></span>
              <ul class="infoList" @click.stop="toNotice" v-if="bell">
                <li data-index="9">
                  我的通知<span data-index="9" v-if="notReadCount"> ({{ notReadCount }})</span>
                </li>
                <li data-index="10">平台公告</li>
              </ul>
            </div>
            <div class="down1">
              <div v-on-clickaway="closeQR" @click="showAppList = !showAppList">
                <img src="../assets/imgs/home/down.png" alt />
                <span>下载APP</span>
              </div>
              <ul class="infoList" @click.stop="showQR" v-if="showAppList">
                <li data-name="矿云通" data-index="1">下载矿云通</li>
                <li data-name="矿易通" data-index="2">下载矿易通</li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <section class="content">
        <div class="flex">
          <aside>
            <ul>
              <li class="" @click="dianji1(index)" v-for="(item, index) in meauNodeList" :key="index">
                <div class="title flex-between-center">
                  <div class="flex-align-center">
                    <img v-if="item.SORTS == 1" src="../assets/imgs/home/user.png" alt />
                    <img v-if="item.SORTS == 2 || item.SORTS == 5" src="../assets/imgs/home/capital.png" alt />
                    <img v-if="item.SORTS == 3" src="../assets/imgs/home/miner.png" alt />
                    <img v-if="item.SORTS == 4" src="../assets/imgs/home/help.png" alt />
                    <span>{{ item.NAME }}</span>
                  </div>
                  <img src="../assets/imgs/home/downArrow.png" alt class="arrow" v-show="!item.fold" />
                  <img src="../assets/imgs/home/upArrow.png" alt class="arrow" v-show="item.fold" />
                </div>
                <div v-show="item.fold" class="itemContent" id="itemContent1" v-for="(item2, index2) in item.childList" :key="index2">
                  <div class="item" :class="menuName == item2.ID ? 'activeBg' : ''" @click.stop="change(item2.NAME, item2.ID)" style="height: 40px">
                    {{ item2.NAME }}
                  </div>
                </div>
              </li>
            </ul>
          </aside>
          <!-- 菜单切换 -->
          <shouye :key="timer" v-if="contentType == 0"></shouye>
          <qiyeSucess :key="timer" v-if="contentType == 20"></qiyeSucess>
          <sellPrice :key="timer" v-if="contentType == 1"></sellPrice>
          <userManage :key="timer" v-if="contentType == 2"></userManage>
          <moneyManage :key="timer" v-if="contentType == 3"></moneyManage>
          <prePayment :key="timer" v-if="contentType == 4"></prePayment>
          <specialMoney :key="timer" v-if="contentType == 5"></specialMoney>
          <charge :key="timer" v-if="contentType == 6"></charge>
          <stationInfo :key="timer" v-if="contentType == 7"></stationInfo>
          <advance :key="timer" v-if="contentType == 23"></advance>
          <arbitrate :key="timer" v-if="contentType == 24"></arbitrate>
          <customer :key="timer" v-if="contentType == 25 && (companyGroup != '' || companyGroup != -1)"></customer>
          <finance :key="timer" v-if="contentType == 26 && (companyGroup != '' || companyGroup != -1)"></finance>
          <accountMgt :key="timer" v-if="contentType == 22"></accountMgt>
          <companyUser :key="timer" v-if="contentType == 8"></companyUser>
          <notice :key="timer" v-if="contentType == 9"></notice>
          <announcement :key="timer" v-if="contentType == 10"></announcement>
          <accountSafe :key="timer" v-if="contentType == 11"></accountSafe>
          <withdraw :key="timer" v-if="contentType == 21"></withdraw>
          <tradeCash :key="timer" v-if="contentType == 27"></tradeCash>
          <preDeclare :key="timer" v-if="contentType == 12"></preDeclare>
          <notpreDeclare :key="timer" v-if="contentType == 13"></notpreDeclare>
          <carManage :key="timer" v-if="contentType == 14"></carManage>
          <settlement :key="timer" v-if="contentType == 19"></settlement>
          <onlineCharge :key="timer" v-if="contentType == 15 || contentType == 16 || contentType == 17 || contentType == 18"></onlineCharge>
        </div>
      </section>
      <foot></foot>
      <!-- 下载弹框 -->
      <div class="alertMask" v-show="alert">
        <div class="alert">
          <div class="alertBox">
            <div class="alertTitle">
              <span>下载{{ download }}手机端</span>
              <img src="../assets/imgs/login/close.png" @click="alert = false" />
            </div>
            <div class="alertContent">
              <div class="alertTab flex-between">
                <div class="tabItem" :class="alertIndex == 1 ? 'active' : ''" @click="alertIndex = 1">手机下载</div>
                <div class="tabItem" :class="alertIndex == 2 ? 'active' : ''" @click="alertIndex = 2">本地下载</div>
              </div>
              <div class="scan" v-show="alertIndex == 1">
                <!--<img src="../assets/imgs/login/scan.png" alt />-->
                <div class="imgbox" id="qrcode" ref="qrcodeDiv2"></div>
                <p>打开手机微信扫一扫下载</p>
              </div>
              <div class="down" v-show="alertIndex == 2">
                <img src="../assets/imgs/login/app.png" alt />
              </div>
            </div>
            <div class="bottom" v-if="alertIndex == 2">
              <button @click="downloadApk" class="downBut">下载</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--加载中-->
    <div v-show="loading" class="demo-spin-container">
      <Spin fix>
        <Icon type="ios-loading" size="100" class="demo-spin-icon-load"></Icon>
        <div style="font-size: 40px">Loading</div>
      </Spin>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  data() {
    return {
      menu: false,
      // 0 shouye; 1 qiyeRenz(企业资料审核中);2 qiyetijiaoZL(企业资料提交成功);3 qiyeSucess（企业审核成功页面）;4 qiyeBiangeng（企业资料变更页面）
      qiyeRenz: 0,
      fold1: false,
      fold2: false,
      fold3: false,
      fold4: false,
      showChild: true,
      userName: '',
      alert: false, //下载APP的弹出层
      bell: false, //右上角小铃铛点击是否展示列表
      showAppList: false, //右上角下载APP点击是否展示列表
      download: '', //下载APP的名字
      alertIndex: 1,
      apkUrl1: '',
      apkUrl2: '',
      kuangYiTongAppDownLoadWeb: '',
      kuangYunTongAppDownLoadWeb: '',
      timer: '',
      meauNodeList: [],
      platformMode: -1,
      loading: true, //首次进入加载loading
      companyGroup: '' // 判断菜单
    };
  },
  computed: {
    ...mapState(['loginInfo', 'contentType', 'menuName', 'notReadCount', 'stationCard'])
  },
  created() {
    if (localStorage.getItem('session')) {
      this.getLoginInfo();
      this.getInfo();
      this.userName = JSON.parse(window.localStorage.getItem('session')).userName;
      this.companyGroup = JSON.parse(window.localStorage.getItem('session')).companyGroup;
    } else {
      this.$router.push({
        name: 'login'
      });
    }
  },
  mounted() {
    this.setMenuName();
    this.hideStation(); //首页过站信息卡片先隐藏
    this.generateQR(1);
    this.getMenuInfo();
    this.getUnread();
    let that = this;
    let session = JSON.parse(localStorage['session']);
    if (!session.sessionId) {
      this.$router.push('/login');
    }
    let from;
    window.sessionStorage.getItem('from') ? (from = window.sessionStorage.getItem('from')) : from;
    if (from == 'grantList' || from == 'wayBill') {
      that.change('预申报矿产调运');
      window.sessionStorage.removeItem('from');
    }
    if (from == 'unWayBill') {
      that.change('非预申报矿产调运');
      window.sessionStorage.removeItem('from');
    }
    if (from == '企业资料') {
      that.change('企业资料');
      window.sessionStorage.removeItem('from');
    }
  },
  methods: {
    ...mapMutations(['setContentType', 'setMenuName', 'showStation', 'hideStation']),
    ...mapActions(['getUnread']),
    //点击页面其他部分关闭小铃铛弹出部分
    closeBell() {
      this.bell = false;
    },
    //点击页面其他部分关闭下载APP弹出部分
    closeQR() {
      this.showAppList = false;
    },
    //nav部分小铃铛平台公告跳转
    toNotice(e) {
      this.bell = false;
      if (e.target.dataset.index == 9) {
        this.setMenuName(localStorage.getItem('notice'));
      } else if (e.target.dataset.index == 10) {
        this.setMenuName(localStorage.getItem('announcement'));
      }
      this.setContentType(e.target.dataset.index);
    },
    //nav部分下载APP列表点击事件
    showQR(e) {
      this.alert = true;
      this.download = e.target.dataset.name;
      this.generateQR(e.target.dataset.index);
    },
    //点击下载安装包
    downloadApk() {
      if (this.download == '矿云通') {
        window.open(this.apkUrl1);
      } else if (this.download == '矿易通') {
        window.open(this.apkUrl2);
      }
    },
    // 获取登录信息
    getInfo() {
      let data = {
        modeCode: 'jgeVwtL1NqOGcbCJHuJCmzqrqcZaVouP'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.socketUrl = res.data.baseSocketUrl;
          this.apkUrl1 = res.data.apkUrl1;
          this.apkUrl2 = res.data.apkUrl2;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    //之前登录返回的部分数据
    getLoginInfo() {
      const session = JSON.parse(localStorage['session']);
      let data = {
        modeCode: 'yiP1UjoswmJAzZfzRKTQMoAoeqkh272X',
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        userId: session.userId
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          localStorage.setItem('platformMode', res.data.platformMode);
          localStorage.setItem('orgName', res.data.orgName);
          localStorage.setItem('fileCommonUrl', res.data.fileCommonUrl);
          localStorage.setItem('uploadFileSocketUrl', res.data.uploadFileSocketUrl);
          localStorage.setItem('orgExt', JSON.stringify(res.data.orgExt));
          localStorage.setItem('platUrl', res.data.platUrl);
          this.kuangYiTongAppDownLoadWeb = res.data.kuangYiTongAppDownLoadWeb;
          this.kuangYunTongAppDownLoadWeb = res.data.kuangYunTongAppDownLoadWeb;
          this.platformMode = JSON.parse(window.localStorage.getItem('session')).platformMode;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    //生成二维码
    generateQR(index) {
      setTimeout(() => {
        this.$refs.qrcodeDiv2.innerHTML = '';
        if (index == 1) {
          let qrcode = new QRCode(this.$refs.qrcodeDiv2, {
            text: this.kuangYunTongAppDownLoadWeb, //二维码内容   url填后台给的链接
            width: 270, //控制二维码高度
            height: 270, //控制二维码宽度
            colorDark: '#000000', //控制二维码前景色
            colorLight: '#ffffff', //控制二维码背景色=
            correctLevel: QRCode.CorrectLevel.L //设置二维码容错率
          });
        } else if (index == 2) {
          let qrcode = new QRCode(this.$refs.qrcodeDiv2, {
            text: this.kuangYiTongAppDownLoadWeb, //二维码内容   url填后台给的链接
            width: 270, //控制二维码高度
            height: 270, //控制二维码宽度
            colorDark: '#000000', //控制二维码前景色
            colorLight: '#ffffff', //控制二维码背景色=
            correctLevel: QRCode.CorrectLevel.L //设置二维码容错率
          });
        }
      }, 500);
    },
    // 回到首页
    goHome() {
      this.setMenuName('a');
      this.setContentType(0);
    },
    // 获取菜单数据
    getMenuInfo: function() {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'GA41gOoIYWzYTWZ5y4oY1ZRqIdsyuAUW'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            if (item.IS_NODE == 1) {
              item.fold = true;
              this.meauNodeList.push(item);
              item.childList = [];
              res.data.forEach((item1) => {
                if (item1.IS_NODE == 0 && item1.FID == item.ID) {
                  item.childList.push(item1);
                }
                if (item1.NAME == '过站信息查询') {
                  this.showStation(); // 如果菜单有过站信息查询部分，把过站信息卡片显示
                }
                if (item1.NAME == '在线充值') {
                  localStorage.setItem('help', item1.ID);
                }
                if (item1.NAME == '过站信息查询') {
                  localStorage.setItem('stationId', item1.ID);
                }
                if (item1.NAME == '我的通知') {
                  localStorage.setItem('notice', item1.ID);
                }
                if (item1.NAME == '平台公告') {
                  localStorage.setItem('announcement', item1.ID);
                }
                if (item1.NAME == '提现管理') {
                  localStorage.setItem('stationId', item1.ID);
                }
              });
            }
          });
          this.loading = false;
        }
      });
    },
    // 退出账号
    loginOut: function() {
      if (localStorage['session']) {
        const session = JSON.parse(localStorage['session']);
        let data = {
          sessionId: session.sessionId,
          modeCode: 'FLw0WC2gyTNKRxaqweEc3MEbifQFpybq'
        };
        this.$http.post(data).then((res) => {
          if (res.code == 1) {
            window.localStorage.removeItem('session');
            this.$router.push('/login');
          } else {
            this.$Message['error']({
              background: true,
              content: res.msg
            });
          }
        });
      } else {
        this.$router.push({
          name: 'login'
        });
      }
    },
    //点击菜单单元节点选项展开折叠
    dianji1: function(id) {
      this.meauNodeList[id].fold = !this.meauNodeList[id].fold;
    },
    //点击菜单子节点切换组件
    change: function(name, id) {
      window.localStorage.setItem('name', name);
      id ? window.localStorage.setItem('fid', id) : null;
      this.timer = new Date().getTime();
      id ? this.setMenuName(id) : this.setMenuName(localStorage.getItem('fid'));
      switch (name) {
        case '企业资料':
          this.setContentType(20);
          break;
        case '矿种售价管理':
          this.setContentType(1);
          break;
        case '客户管理':
          this.setContentType(2);
          break;
        case '资金管理':
          this.setContentType(3);
          break;
        case '交易预付款明细':
          this.setContentType(4);
          break;
        case '矿云通专款明细':
          this.setContentType(5);
          break;
        case '交易预付款充值':
          this.setContentType(6);
          break;
        case '过站信息查询':
          this.setContentType(7);
          break;
        case '企业用户':
          this.setContentType(8);
          break;
        case '我的通知':
          this.setContentType(9);
          break;
        case '平台公告':
          this.setContentType(10);
          break;
        case '账户安全':
          this.setContentType(11);
          break;
        case '预申报矿产调运':
          this.setContentType(12);
          break;
        case '非预申报矿产调运':
          this.setContentType(13);
          break;
        case '常用车辆管理':
          this.setContentType(14);
          break;
        case '在线充值':
          this.setContentType(15);
          break;
        case '开通中资云用户':
          this.setContentType(16);
          break;
        case '修改企业认证':
          this.setContentType(17);
          break;
        case '修改管理员认证':
          this.setContentType(18);
          break;
        case '交收单过站查询':
          this.setContentType(19);
          break;
        case '资金提现':
          this.setContentType(21);
          break;
        case '账户管理':
          this.setContentType(22);
          break;
        case '货款提现申请':
          this.setContentType(23);
          break;
        case '交易提现':
          this.setContentType(27);
          break;
        case '违约仲裁':
          this.setContentType(24);
          break;
        case '用户管理':
          this.setContentType(25);
          break;
        case '资金明细':
          this.setContentType(26);
          break;
        default:
          break;
      }
      if (name == '企业资料') {
        this.shouye = false;
        this.qiyeRenz = 2;
      }
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="less" scoped>
#home {
  background-color: #f9fafc;
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  header {
    background: #f7f9fd;

    .headerTop {
      height: 34px;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #616c84;
      letter-spacing: -0.43px;

      .rightItem {
        cursor: pointer;
      }

      .rightItem:first-child::after {
        content: '|';
        padding: 0 10px;
      }

      .user {
        color: #2c59c3;
      }
    }
  }

  nav {
    background: #2c59c3;
    color: #fff;
    height: 60px;
    line-height: 60px;

    .logo {
      cursor: pointer;

      img {
        vertical-align: middle;
      }
    }

    .infoBox {
      position: relative;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      & > span {
        width: 6px;
        height: 6px;
        display: block;
        border-radius: 50%;
        background: #ff3100;
        position: absolute;
        top: 22px;
        right: 22px;
      }

      .infoList {
        position: absolute;
        top: 40px;
        left: -75px;
        width: 160px;
        height: 88px;
        background: url('../assets/imgs/home/infoBg.png') no-repeat;
        box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
        z-index: 666;
        border-radius: 10px;
        color: #999999;

        li {
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #999;
          letter-spacing: 0.26px;
        }

        li:first-child {
          margin-top: 8px;
          border-bottom: 1px solid #ebedf3;
        }

        li:hover {
          color: #4a4a4a;
        }

        span {
          color: red;
        }
      }
    }

    .infoBox::after {
      content: '|';
      padding: 0 10px;
    }

    .down1 {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      cursor: pointer;
      position: relative;

      img {
        vertical-align: middle;
        margin-right: 5px;
      }

      .infoList {
        position: absolute;
        top: 40px;
        left: -75px;
        width: 160px;
        height: 88px;
        background: url('../assets/imgs/home/infoBg.png') no-repeat;
        box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
        z-index: 666;
        border-radius: 10px;
        color: #999999;

        li {
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #999;
          letter-spacing: 0.26px;
        }

        li:first-child {
          margin-top: 8px;
          border-bottom: 1px solid #ebedf3;
        }

        li:hover {
          color: #4a4a4a;
        }

        span {
          color: red;
        }
      }
    }
  }

  // 中间内容
  section {
    min-height: 730px;
    padding: 20px 0;

    aside {
      width: 200px;
      height: 100%;
      background: #ffffff;
      border: 1px solid #ebebeb;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      // height: 400px;
      overflow: hidden;

      ul {
        cursor: pointer;

        li {
          list-style: none;
        }

        .title {
          width: 100%;
          padding: 0 15px;
          height: 40px;
          line-height: 40px;
          background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
          border-radius: 10px 10px 0 0;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #616c84;
          letter-spacing: -0.57px;

          img {
            margin-right: 10px;
          }

          .arrow {
            text-align: right;
            vertical-align: middle;
          }
        }

        .itemContent {
          .item {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #616c84;
            letter-spacing: -0.57px;
            padding: 0 0 0 40px;
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }

    .middle {
      width: 560px;
      margin: 0 20px;
    }

    .bg {
      background: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 15px;
    }

    .company {
      .companyImg {
        margin-bottom: 10px;
      }

      .companyName {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #4a4a4a;
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 15px;
      }

      .certified {
        margin: 0 5px;
      }

      .companyLine {
        margin: 5px 0;

        .msgTitle {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0;
        }

        .msgContent {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0;
        }

        .admin {
          margin: 0 5px;
          vertical-align: middle;
        }
      }
    }

    .account {
      border-top: 5px solid #2c59c3;
      border-radius: 5px;
      background: #f5f5f5 url('../assets/imgs/home/accountBg.png') no-repeat;
      background-position: 100%;
      width: 520px;
      height: 155px;
      margin: 10px auto;
      box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);

      .accountBox {
        width: 90%;
        margin: 15px auto;

        .left {
          width: 35%;
          border-right: 1px dashed #ebedf3;

          span {
            margin: 0 10px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #2c59c3;
            letter-spacing: 0.39px;
            font-weight: 600;
          }

          .downAccount {
            width: 117px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
            border: 1px solid #285ed3;
            border-radius: 4px;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0.3px;
            margin: 65px 0 0;
          }
        }

        .right {
          position: relative;
          padding-left: 30px;

          .line {
            margin: 10px 0;
          }

          .title {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #8b93a7;
            letter-spacing: 0.3px;
          }

          .con {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #25265e;
            letter-spacing: 0.3px;
          }

          .copy {
            margin-left: 40px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #c2c2d2;
            letter-spacing: 0;

            img {
              vertical-align: middle;
            }
          }

          .problem {
            position: absolute;
            top: -85px;
            left: 280px;
            background: url('../assets/imgs/home/problemBg.png') no-repeat;
            background-size: 100%;
            width: 487px;
            height: 216px;

            .problemBox {
              width: 80%;
              margin: 20px 0 0 58px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #000000;
              line-height: 24px;

              .title {
                font-size: 12px;
                color: #8b93a7;
              }
            }
          }
        }
      }

      .noCertified {
        color: #c3c3c3;

        .title {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #abafb7;
          letter-spacing: 0;
          margin: 20px 0 10px 100px;
        }

        .stepBox {
          margin: 0 30px;

          .step {
            .num {
              width: 26px;
              height: 26px;
              line-height: 26px;
              border-radius: 50%;
              border: 1px solid #c3c3c3;
              color: #c3c3c3;
              text-align: center;
              margin: 0 5px;
            }
          }

          .line {
            width: 20px;
            height: 1px;
            margin: 0 10px;
            background: #c3c3c3;
          }
        }

        .certifiedBut {
          background-image: linear-gradient(180deg, #fa7864 0%, #f44334 100%);
          border: 1px solid #f44536;
          box-shadow: 0 3px 6px 0 rgba(244, 67, 52, 0.4);
          border-radius: 4px;
          width: 130px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.37px;
          margin: 10px 120px;
          cursor: pointer;
        }

        .noCertifiedImg {
          float: right;
          margin-top: -115px;
          margin-right: 25px;
        }
      }
    }

    .titleLine {
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf3;

      .left {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.4px;
        font-weight: 600;
      }

      .right {
        cursor: pointer;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #2c59c3;
        letter-spacing: 0.35px;

        img {
          margin-left: 10px;
        }
      }
    }

    .numberBox {
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8b93a7;
      letter-spacing: 0.35px;
      margin: 20px 0 0;

      .line {
        width: 1px;
        height: 30px;
        background: #ebedf3;
      }

      h1 {
        font-family: Impact;
        letter-spacing: 0.85px;
        font-size: 34px;
        margin: 15px 0 0;
      }

      .item {
        height: 87px;

        p {
          margin-bottom: 25px;
        }

        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
        }
      }

      .train {
        h1 {
          color: #7ed321;
        }
      }

      .weight {
        h1 {
          color: #4a90e2;
        }
      }

      .total {
        h1 {
          color: #f5a623;
        }
      }

      .all {
        h1 {
          color: #f87117;
        }
      }

      .noOpen {
        height: 87px;

        p {
          margin-bottom: 30px;
        }

        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
        }
      }

      .special {
        h1 {
          color: #2c59c3;
        }
      }
    }

    .infoLine {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4a4a4a;
      letter-spacing: 0.35px;
      margin: 10px 0;

      .text {
        width: 65%;

        span {
          white-space: nowrap;
          /*设置不换行*/
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .time {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #8b93a7;
        letter-spacing: 0.35px;
      }
    }

    //在线充值
    .recharge {
      width: 400px;

      .rechargeBox {
        margin: 20px 10px;

        .title {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0.35px;
        }

        .total {
          font-family: Impact;
          font-size: 42px;
          color: #f87117;
          letter-spacing: 1.05px;
          margin: 5px 0;
        }
      }

      .item {
        width: 360px;
        background: #ffffff;
        margin: auto;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        border-radius: 10px;

        .payTitle {
          border-radius: 10px 10px 0 0;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
        }

        .payContent {
          width: 80%;
          margin: 15px auto;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          letter-spacing: 0;
          line-height: 22px;
          text-indent: 2em;
        }

        .noOpen {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d0d4dc;
          letter-spacing: 0.37px;
          text-align: center;
          margin: 35px 0;
        }

        .bottom {
          text-align: center;
          margin-top: 15px;
          border-top: 1px solid #ebedf3;

          img {
            margin-top: 8px;
          }
        }
      }

      // 网银
      .online {
        height: 232px;

        .payTitle {
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #f15949 100%);
        }

        .demo {
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #af2534;
          letter-spacing: 0;
          margin-top: 50px;

          img {
            vertical-align: middle;
            margin: 0 4px;
          }
        }
      }

      // 银联
      .card {
        height: 159px;
        margin: 20px auto;

        .payTitle {
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #0b91d7 100%);
        }
      }

      // 快捷支付
      .wx {
        height: 159px;

        .payTitle {
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #00ac1c 100%);
        }
      }
    }

    // 矿产调运
    .mineral {
      width: 400px;
      height: 422px;

      .box {
        width: 360px;
        margin: 30px auto;
        background: #ffffff;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        border-radius: 10px;

        .title {
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #2c59c3 100%);
          border-radius: 10px 10px 0 0;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.37px;
        }

        .contentImg {
          text-align: center;
          margin: 30px auto;
        }

        .bottom {
          border-top: 1px dashed #ebedf3;
          height: 60px;

          .but {
            background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
            border: 1px solid #4c9b25;
            border-radius: 4px;
            width: 117px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.35px;
            margin: 15px auto;
            cursor: pointer;
          }
        }
      }
    }
  }

  /* 弹出层 */
  .alert {
    width: 600px;
    height: 466px;
    background: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -233px;
    margin-left: -300px;
  }

  .alertBox {
    position: relative;
    height: 466px;
  }

  .alert .alertTitle {
    height: 46px;
    line-height: 46px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.34px;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
    border-radius: 10px 10px 0 0;
    text-align: center;
  }

  .alert .alertTitle img {
    float: right;
    margin: 14px 10px 0 0;
    cursor: pointer;
  }

  .alert .alertContent {
    width: 50%;
    margin: 20px auto;
  }

  .alert .alertContent .alertTab {
    position: relative;
  }

  .alert .alertContent .alertTab .tabItem {
    width: 120px;
    height: 30px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #d7d7d7;
    letter-spacing: 0.3px;
    font-weight: 600;
    cursor: pointer;
  }

  .alert .alertContent .alertTab .tabItem:first-child::after {
    content: '';
    border-right: 1px solid #d7dce7;
    height: 20px;
    position: absolute;
    top: 0;
    left: 50%;
  }

  /* 激活样式 */
  .alert .alertContent .alertTab .tabItem.active {
    border-bottom: 2px solid #2255ce;
    color: #2255ce;
  }

  .scan {
    text-align: center;
    margin: 30px auto;
  }

  .scan p {
    margin: 20px 0;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0.22px;
  }

  .down {
    margin: 50px auto;
    text-align: center;
  }

  .bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f5f5f5;
    border-radius: 0 0 10px 10px;
    text-align: center;
  }

  .bottom .downBut {
    background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
    border: 1px solid #285ed3;
    border-radius: 4px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    width: 138px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  .imgbox {
    width: 270px;
    height: 270px;
    // margin-left: 45px;
  }
}

.activeBg {
  background: rgba(44, 89, 195, 0.7);
  color: white !important;
  border-right: 4px solid #2c59c3;
}
</style>
